import 'ui-core/components/tabs/js/tabs';
(function () {
    UX.tab.on.dropdownBuild = function ($ele, index) {
        if (UX.dropBlock) {
            UX.dropBlock.init();
        }

        $ele.wrap('<div class="dropBlock no-auto-width" data-db-parent-of="dbTab-' + index + '"></div>');

        const $dropdownContainer = $ele.closest('.dropBlock');
        const $activeTab = $ele.find('.active a');

        if ($ele.find('>li').length === 1) {
            $dropdownContainer.prepend(
                `<a href='#' class='dropBlock__link no-pointer-events' data-db-target-for='dbTab-${index}'><span>${$activeTab.text()}</span></a>`
            );
            $ele.hide();
        } else {
            $dropdownContainer.prepend(
                `<a href='#'class='dropBlock__link' data-db-target-for='dbTab-${index}'><span>${$activeTab.text()}</span><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><path d='M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z'/></svg></a>`
            );
            $ele.attr('data-db-target-of', 'dbTab-' + index);
        }
    };
})();
